<template>
  <div class="g-box">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow">Site Map</h1>
        <section class="g-unit-xl">
          <p><b>トップページ</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/en'">Top</router-link></li>
          </ul>
        </section>
        <section class="g-unit-xl">
          <p><b>プロジェクトから探す</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/en/search?dbs=taiwan'">Material Culture in Taiwan and Neighboring Islands</router-link></li>
            <li><router-link class="g-link" :to="'/en/search?dbs=georgebrown'">The George Brown Collection</router-link></li>
            <li><router-link class="g-link" :to="'/en/search?dbs=jpculture'">“Culture of Japan” Exhibition Database</router-link></li>
            <li><router-link class="g-link" :to="'/en/search?dbs=canada'">The Cultural Resources of Indigenous Peoples in Northern North America</router-link></li>
            <li><router-link class="g-link" :to="'/en/search?dbs=mepc'">Database for Popular Culture Collections from the Middle East</router-link></li>
          </ul>
        </section>
        <section class="g-unit-xl">
          <p><b>索引から探す</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/en/index/id'">Registration Number</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/name'">Object Name</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/age'">Date</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/area'">Place</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/nation'">Group</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/owc'">Outline of World Cultures (OWC)</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/ocm'">Outline of Cultural Materials (OCM)</router-link></li>
            <li><router-link class="g-link" :to="'/en/index/fyear'">Date of Coll.</router-link></li>
          </ul>
        </section>
        <section class="g-unit-xl">
          <p><b>その他</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/en/about'">About this site</router-link></li>
            <li><router-link class="g-link" :to="'/en/link'">Links</router-link></li>
          </ul>
        </section>
    </main>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components: {
    breadcrumb
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/sitemap', text: 'Site.sitemap' },
      ]
    },
  }
}

</script>